<h2 mat-dialog-title *transloco="let t">{{ t('cancelOrderTitle') }}</h2>
<mat-dialog-content class="mat-typography" *transloco="let t">
  {{ t('cancelOrderDialog') }} <b>{{ data.orderNo }}</b>?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onSubmit()">Yes</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>No</button>
</mat-dialog-actions>